import { NgModule } from '@angular/core';
import { NavigationEnd, NavigationStart, RouteConfigLoadEnd, RouteConfigLoadStart, Router, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { AppRouteGuard } from './shared/common/auth/auth-route-guard';
import { NotificationsComponent } from './shared/layout/notifications/notifications.component';
import { NgxSpinnerService } from 'ngx-spinner';

@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: 'app',
                component: AppComponent,
                canActivate: [AppRouteGuard],
                canActivateChild: [AppRouteGuard],
                children: [
                    {
                        path: '',
                        children: [
                            { path: 'notifications', component: NotificationsComponent },
                            { path: '', redirectTo: '/app/main/dashboard', pathMatch: 'full' },
                        ],
                    },
                    {
                        path: 'main',
                        loadChildren: () => import('app/main/main.module').then((m) => m.MainModule), //Lazy load main module
                        data: { preload: true },
                    },
                    {
                        path: 'master',
                        loadChildren: () => import('app/master/master.module').then((m) => m.MasterModule), //Lazy load main module
                        data: { preload: true },
                    },
                    {
                        path: 'account',
                        loadChildren: () => import('app/account/account.module').then((m) => m.AccountModule), //Lazy load main module
                        data: { preload: true },
                    },
                    {
                        path: 'inventory',
                        loadChildren: () => import('app/inventory/inventory.module').then((m) => m.InventoryModule), //Lazy load main module
                        data: { preload: true },
                    },
                    {
                        path: 'sales',
                        loadChildren: () => import('app/sales/sales.module').then((m) => m.SalesModule), //Lazy load main module
                        data: { preload: true },
                    },
                     {
                        path: 'purchase',
                        loadChildren: () => import('app/purchase/purchase.module').then((m) => m.PurchaseModule), //Lazy load main module
                        data: { preload: true },
                    },
                    {
                        path: 'stock',
                        loadChildren: () => import('app/stock/stock.module').then((m) => m.StockModule), //Lazy load main module
                        data: { preload: true },
                    },
                    {
                        path: 'inventory',
                        loadChildren: () => import('app/inventory/inventory.module').then((m) => m.InventoryModule), //Lazy load main module
                        data: { preload: true },
                    },
                    {
                        path: 'admin',
                        loadChildren: () => import('app/admin/admin.module').then((m) => m.AdminModule), //Lazy load admin module
                        data: { preload: true },
                        canLoad: [AppRouteGuard],
                    },
                    {
                        path: '**',
                        redirectTo: 'notifications',
                    },
                ],
            },
        ]),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {
    constructor(private router: Router, private spinnerService: NgxSpinnerService) {
        router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                spinnerService.show();
            }

            if (event instanceof NavigationEnd) {
                document.querySelector('meta[property=og\\:url').setAttribute('content', window.location.href);
                spinnerService.hide();
            }
        });
    }
}
